import { Tooltip } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityNamespaceType, CuriosityTranslation, CuriosityValue } from '@procureai/curiosity-ui-mui';
import { Restricted, RestrictionCheck } from '@procureai/permissions-ui';
import { Union } from 'ts-toolbelt';

import { DataGridLink } from '../../components/DataGridLink';
import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type CommodityLinkCellValue = Union.Nullable<string>;

interface CommodityLinkCellProps<R extends GridValidRowModel = any> {
  value: CommodityLinkCellValue;
  row?: R;
  to?: string;
  needs?: RestrictionCheck;
}

export const CommodityLinkCell = <R extends GridValidRowModel = any>({
  value: i18nKey,
  to,
  needs,
}: CommodityLinkCellProps<R>) => {
  if (!i18nKey) {
    return <>{NULLISH_CELL_VALUE}</>;
  }
  return (
    <CuriosityValue ns={CuriosityNamespaceType.COMMODITY} i18nKey={i18nKey} valueGetter={(ct) => ct}>
      {(value) => {
        const label = (value as CuriosityTranslation).value;
        const primarySourceReference = (value as CuriosityTranslation).entity?.primarySourceReference;
        const title = (
          <Tooltip title={label}>
            <span>{primarySourceReference}</span>
          </Tooltip>
        );
        if (to) {
          return (
            <Restricted needs={needs} fallback={title}>
              <Tooltip title={label}>
                <span>
                  <DataGridLink to={to}>{primarySourceReference}</DataGridLink>
                </span>
              </Tooltip>
            </Restricted>
          );
        }
        return title;
      }}
    </CuriosityValue>
  );
};
